import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, ModalFooter, Stack, Textarea } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import ButtonGroup from '../../../../../../../../../../../../../../components/Modal/ModalButtonGroups/ButtonGroup';
import { updateItemCodeStatus } from '../../../../../../../../../../../../../../redux/modules/items';
import { hideModal } from '../../../../../../../../../../../../../../redux/modules/modal';

const CommentModal = ({ itemId, codeId, codeAction, letter }) => {
  const dispatch = useDispatch();
  const [comment, setComment] = useState();

  const handleCommentChange = e => {
    const newComment = e.target.value;
    setComment(newComment);
  };

  return (
    <Box>
      <Stack flexBasis="100%" minWidth="300px">
        <Textarea size="md" onChange={e => handleCommentChange(e)} />
        <ModalFooter>
          <ButtonGroup
            label="Save"
            secondaryClick={() => {
              dispatch(updateItemCodeStatus(itemId, codeId, codeAction, letter));
              dispatch(hideModal());
            }}
            secondaryLabel="Skip"
            onClick={() => {
              dispatch(updateItemCodeStatus(itemId, codeId, codeAction, letter, comment));
              dispatch(hideModal());
            }}
          />
        </ModalFooter>
      </Stack>
    </Box>
  );
};

CommentModal.propTypes = {
  itemId: PropTypes.number,
  codeId: PropTypes.number,
  codeAction: PropTypes.string,
  letter: PropTypes.string
};

export default CommentModal;
